import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductTypeSalesUnit, ProductTypeSalesUnits, SellingUnitConversion } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeSalesUnitService extends TmsWebBaseEditCreateService<
  ProductTypeSalesUnit,
  ProductTypeSalesUnit
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ProductTypeSalesUnit', $localize`Product Type Sales Unit`);
  }

  getForProductTypeSales(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductTypeSales/${id}`);
  }

  getSellingUnitForProductType(productTypeId: string): Observable<ProductTypeSalesUnit[]> {
    return this.httpService.get<ProductTypeSalesUnit[]>(`${this.apiUrl}/ProductType/${productTypeId}`);
  }

  getAllSellingUnitsForProductTypes(productTypeId: string): Observable<ProductTypeSalesUnits[]> {
    return this.httpService.get<ProductTypeSalesUnits[]>(`${this.apiUrl}/GetAllSellingUnits/${productTypeId}`);
  }

  updateSellingUnitProductTypes(productTypeId: string, SellingUnitIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateSellingUnitsProductTypes`, { productTypeId, SellingUnitIds });
  }

  getSellingConversionQty(id: string, orderUnitOfMeasureId: string): Observable<SellingUnitConversion> {
    return this.httpService.get<SellingUnitConversion>(
      `${this.apiUrl}/GetSellingConversionQty?id=${id}&orderUnitOfMeasureId=${orderUnitOfMeasureId}`,
    );
  }
}
